import React from "react";
import { ArrowRight } from "lucide-react";
import { blogs } from "../mock";
import Reveal from "./Reveal";
import { toast } from "../hooks/use-toast";

export default function Blogs() {
  return (
    <section id="blogs" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="flex items-end justify-between mb-12">
          <h2 className="section-title text-3xl md:text-5xl">Blogs</h2>
          <button
            onClick={() => toast({ title: "Blog section", description: "Full articles will be available soon." })}
            className="inline-flex items-center gap-2 text-[color:var(--brand-blue)] font-semibold hover:gap-3 transition-all"
          >
            View All <ArrowRight size={18} />
          </button>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {blogs.map((b, i) => (
            <Reveal key={b.title} delay={i * 100}>
              <article className="card-hover h-full bg-white rounded-2xl overflow-hidden border border-slate-100 flex flex-col">
                <div className="overflow-hidden">
                  <img src={b.image} alt={b.title} className="h-48 w-full object-cover hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <span className="self-start text-xs font-semibold px-3 py-1 rounded-full mb-3" style={{ background: "var(--brand-ice)", color: "var(--brand-blue)" }}>
                    {b.category}
                  </span>
                  <h3 className="font-head font-semibold text-lg leading-snug mb-3" style={{ color: "var(--brand-navy)" }}>{b.title}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed flex-1">{b.excerpt}</p>
                  <div className="mt-5 flex items-center justify-between text-xs text-slate-400">
                    <span>Bhawani Kitchen</span>
                    <span>{b.date}</span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
